import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="container-fluid footer py-2">
            <p className="text text-light text-center lh-lg">&copy; Md. Roman Sheikh 2022 || All Rights Reserved</p>
        </div>
    );
};

export default Footer;